import { SIREN_CONFIG } from "config.js";

import {useSelector} from 'react-redux';

/**
 * 병실 리스트 및 병실 이름 얻기
 */
export let roomList = [];

export async function loadRoomList(facility_id){
    // console.log("loadRoomList: ", roomList);

    // console.log("facility_id: ---- " + facility_id);


    if (roomList.length > 0) {
        return roomList;
    }

    var url = `${SIREN_CONFIG.HOSTNAME}/room/roomlist?facility_id=${facility_id}`;
    const opt = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };

    roomList = [];
    let response = await fetch(url, opt);
    let responseData = await response.json();
    responseData.resultData.map(function (row) {
        roomList.push(
        { roomId: row['roomId'], roomName: row['roomName'] }
      );
    });

    // console.log("ret: ", roomList);
    return roomList;
}


export const getRoomName = (roomId) => {
  var ret = {};
  roomList.forEach(room => {
    // console.log(room);
    // console.log(roomId);
    if (room.roomId === roomId) {
      ret = { roomId: room.roomId, roomName: room.roomName };
    }
  });
  return ret;
}


export let caregiverRoomList = [];
export async function loadCaregiverRoomList(facility_id, caregiverId){

  // if (caregiverRoomList.length > 0) {
  //   return caregiverRoomList;
  // }

  var url = `${SIREN_CONFIG.HOSTNAME}/room/roomListWithCaregiver?facility_id=${facility_id}&caregiverId=${caregiverId}`;
  const opt = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  caregiverRoomList = [];
  let response = await fetch(url, opt);
  let responseData = await response.json();

  responseData.resultData.map(function (row) {
    // console.log("row: " + JSON.stringify(row));
    caregiverRoomList.push(
      { roomId: row['roomId'], roomName: row['roomName'], isMine: row['isMine'] }
    );
  });

  // console.log("ret: ", caregiverRoomList);
  return caregiverRoomList;
}


/**
 * 요양사 리스트 및 이름, 전화번호 얻기
 */

export let caregiverList = [];

export async function loadCaregiverList(facility_id){
  // console.log("loadCaregiverList: ", caregiverList);

  var url = `${SIREN_CONFIG.HOSTNAME}/caregiver/caregiverList?facility_id=${facility_id}`;

  if(caregiverList.length > 0){
    return caregiverList;
  }

  const opt = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  };

  caregiverList = [];

  let response = await fetch(url, opt);
  let responseData = await response.json();
  responseData.resultData.map(function(row){
    caregiverList.push(
        {caregiverId: row['caregiverId'],
         caregiverName: row['caregiverName'],
        caregiverTelNo: row['caregiverTelNo']}
    );
  });

  return caregiverList;
}

/**
 * Autocomplete의 value 값 매핑
 * @param {*} caregiverId
 * @returns
 */
export const getCaregiverValue = (caregiverId) => {
  var ret = {};
  caregiverList.forEach( caregiver => {
    if (caregiver.caregiverId == caregiverId){
      ret = {caregiverId: caregiver.caregiverId, caregiverName: caregiver.caregiverName, caregiverTelNo: caregiver.caregiverTelNo};
    }
  });

  return ret;
}

/**
 * caregiverId로 caregiver의 Name를 얻는다
 * @param {*} caregiverId
 * @returns
 */
export const getCaregiverName = (caregiverId) => {
  var ret = "";
  caregiverList.forEach( caregiver => {
    if(caregiver.caregiverId == caregiverId){
      ret = caregiver.caregiverName;
    }
  });

  return ret;
}


/**
 * caregiverId로 caregiver의 TelNo를 얻는다.
 * @param {*} caregiverId
 * @returns
 */
export const getCaregiverTelNo = (caregiverId) => {
  var ret = "";
  caregiverList.forEach( caregiver => {
    if(caregiver.caregiverId == caregiverId){
      ret = caregiver.caregiverTelNo;
    }
  });

  return ret;
}
